import React from 'react';

import { useDispatch } from 'react-redux';

import SeenIcon from 'assets/chat/ActionIcon/seen.svg';
import DefaultAvatar from 'assets/chat/img.svg';
import EmailMessage from 'common-ui/chat/EmailMessage';
import { formatDateTime } from 'utils/dateUtils';

import {
  ChatSingleHeaderIcon,
  ChatSingleItemRight,
  ChatSingleItemRightContent,
  ChatSingleItemRightMessage,
  ChatSingleItemRightMessageText,
  ChatSingleItemRightName,
  ChatSingleItemRightTime,
  ChatSingleItemRightTimeStatus,
} from '../ChatSingle.styles';
import AttachmentRenderer from './AttachmentRenderer';
import AttachmentWrapper from './AttachmentWrapper';

const getMessageSenderName = (message) => {
  if (message.sentBy) {
    if (message.sentBy.name && message.sentBy.surname) {
      return `${message.sentBy.name} ${message.sentBy.surname}`;
    }
    if (message.sentBy.name) {
      return message.sentBy.name;
    }
    if (message.sentBy.userId) {
      return `User ${message.sentBy.userId.slice(-6)}`;
    }
  }
  return 'Unknown User';
};

const isMediaTypeIndicator = (text) => {
  if (!text) return false;
  const trimmed = text.trim();
  return /^\[(Audio|Video|Image|Sticker|Document|File|Photo|Contact shared)\]$/i.test(trimmed);
};

const shouldDisplayMessageText = (messageText, hasAttachments) => {
  if (!messageText) return false;
  if (!hasAttachments) return true;
  return !isMediaTypeIndicator(messageText);
};

const ChatSingleItemRightComponent = ({ message, platform, conversation }) => {
  const dispatch = useDispatch();

  if (message.platform === 'imap') {
    return (
      <ChatSingleItemRight key={message._id}>
        <ChatSingleHeaderIcon src={message.sentBy?.avatar || DefaultAvatar} />
        <ChatSingleItemRightContent>
          <ChatSingleItemRightName>{getMessageSenderName(message)}</ChatSingleItemRightName>
          <EmailMessage message={message} isMyMessage={true} />
          <ChatSingleItemRightTime>
            {formatDateTime(
              message.timestamp || message.createdAt,
              false,
              false,
              'MMM D h:mm A'
            )}
            {message.isRead && <ChatSingleItemRightTimeStatus src={SeenIcon} />}
          </ChatSingleItemRightTime>
        </ChatSingleItemRightContent>
      </ChatSingleItemRight>
    );
  }

  return (
    <ChatSingleItemRight key={message._id}>
      <ChatSingleHeaderIcon src={message.sentBy?.avatar || DefaultAvatar} />
      <ChatSingleItemRightContent>
        <ChatSingleItemRightName>{getMessageSenderName(message)}</ChatSingleItemRightName>
        <ChatSingleItemRightMessage>
          {shouldDisplayMessageText(
            message.messageText,
            message.attachments && message.attachments.length > 0
          ) && (
            <ChatSingleItemRightMessageText>
              {message.messageText}
            </ChatSingleItemRightMessageText>
          )}
          {message.attachments && message.attachments.length > 0 && (
            <AttachmentWrapper $isMyMessage={true}>
              <AttachmentRenderer
                attachments={message.attachments}
                isMyMessage={true}
                platform={platform}
                message={message}
                dispatch={dispatch}
              />
            </AttachmentWrapper>
          )}
        </ChatSingleItemRightMessage>
        <ChatSingleItemRightTime>
          {formatDateTime(
            message.timestamp || message.createdAt,
            false,
            false,
            'MMM D h:mm A'
          )}
        </ChatSingleItemRightTime>
      </ChatSingleItemRightContent>
    </ChatSingleItemRight>
  );
};

export default ChatSingleItemRightComponent;
